import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const RejectReasonDialog = ({ visible, request, onHide, onConfirm, isSubmitting }) => {
    const { th } = useLanguage();
    const [returnMessage, setReturnMessage] = useState('');
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        if (visible) {
            setReturnMessage('');
            setSubmitted(false);
        }
    }, [visible]);

    const handleConfirm = () => {
        setSubmitted(true);
        if (!returnMessage || returnMessage.trim().length === 0) return;
        onConfirm(returnMessage.trim());
    };

    const footer = (
        <div className="flex justify-content-end gap-2">
            <Button label={th('common.cancel')} icon="pi pi-times" className="p-button-text" onClick={onHide} disabled={isSubmitting} />
            <Button label={th('formDateChangeRequest.dialog.rejectConfirm')} icon="pi pi-times-circle" className="p-button-danger" onClick={handleConfirm} loading={isSubmitting} />
        </div>
    );

    return (
        <Dialog visible={visible} style={{ width: '450px' }} header={th('formDateChangeRequest.dialog.rejectTitle')} modal footer={footer} onHide={onHide}>
            {request && <p className="text-700 mb-3">{th('formDateChangeRequest.dialog.rejectMessage', { chassisNo: request.chassisNo })}</p>}
            <div className="field">
                <label htmlFor="returnMessage" className="font-bold block mb-2">
                    {th('formDateChangeRequest.dialog.returnMessageLabel')} *
                </label>
                <InputTextarea
                    id="returnMessage"
                    value={returnMessage}
                    onChange={(e) => setReturnMessage(e.target.value)}
                    rows={4}
                    autoFocus
                    maxLength={1000}
                    className={submitted && !returnMessage.trim() ? 'p-invalid w-full' : 'w-full'}
                    placeholder={th('formDateChangeRequest.dialog.returnMessagePlaceholder')}
                />
                {submitted && !returnMessage.trim() && <small className="p-error">{th('formDateChangeRequest.dialog.returnMessageRequired')}</small>}
            </div>
        </Dialog>
    );
};

export default RejectReasonDialog;
